import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "nx-components/utils/prefixStyles";
import { Divider } from "nx-components/ItemList";
import Spinner from "nx-components/Spinner";
import NewsPage from "./NewsPage";
import NewsControls from "./NewsControls";

const styles = prefixStyles({
  wrapper: {
    width: "14em",
    maxWidth: "80vw",
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    position: "relative", // for spinnerWrapper
  },
  pageWrapper: {
    padding: "0.5em",
    overflow: "auto",
  },
  spinnerWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
  dividerWrapper: {
    flexShrink: "0",
  },
});

export default class DumbNews extends React.Component {
  static propTypes = {
    hasPreviousPage: PropTypes.bool.isRequired,
    showPreviousPage: PropTypes.func.isRequired,
    hasNextPage: PropTypes.bool.isRequired,
    showNextPage: PropTypes.func.isRequired,
    isShowNewsChecked: PropTypes.bool.isRequired,
    onShowNewsClicked: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    headline: PropTypes.string.isRequired,
    publishedDate: PropTypes.instanceOf(Date).isRequired,
    content: PropTypes.string.isRequired,
  };

  render() {
    const {
      hasPreviousPage,
      showPreviousPage,
      hasNextPage,
      showNextPage,
      isShowNewsChecked,
      onShowNewsClicked,
      isLoading,
      headline,
      publishedDate,
      content,
    } = this.props;

    return (
      <div data-component-name="DumbNews" style={styles.wrapper}>
        <div style={styles.pageWrapper}>
          <NewsPage
            headline={headline}
            publishedDate={publishedDate}
            content={content}
          />
        </div>
        <div style={styles.dividerWrapper}>
          <Divider />
        </div>
        <NewsControls
          isShowNewsChecked={isShowNewsChecked}
          onShowNewsClicked={onShowNewsClicked}
          onBackArrowClicked={hasPreviousPage ? showPreviousPage : undefined}
          onForwardArrowClicked={hasNextPage ? showNextPage : undefined}
        />
        {isLoading && (
          <div style={styles.spinnerWrapper}>
            <Spinner diameter={96} />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/News/DumbNews.jsx